import { Menu, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import NotificationBell from "@/components/NotificationBell";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1791f9d8-ffce-4632-931c-e01b5c5c94c3/artifacts/sbeyyf6q_1000003487.png";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 bg-[#0284C7] text-white h-14 flex items-center justify-between px-4"
    >
      <button
        data-testid="header-menu-btn"
        onClick={onMenuClick}
        className="p-2 transition-none"
      >
        <Menu size={22} />
      </button>

      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => navigate("/")}
        data-testid="header-logo"
      >
        <img src={LOGO_URL} alt="Logo" className="w-8 h-8 object-contain" />
        <span className="font-bold text-sm tracking-tight" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Smart English Fast English
        </span>
      </div>

      <div className="flex items-center gap-1">
        <NotificationBell />
        <button
          data-testid="header-profile-btn"
          onClick={() => navigate("/profile")}
          className="p-2 transition-none"
        >
          <User size={20} />
        </button>
      </div>
    </header>
  );
}
